import fileDownload from "js-file-download";

import { baseApi } from "api/BaseApi";

import { EcrImportParams } from "../ecr.types";

const ECR_BASE_URL = "ecr";

const ecrExcelApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    importEcrs: build.mutation<void, EcrImportParams>({
      query: (params) => ({
        url: `${ECR_BASE_URL}/excel_import/`,
        params,
      }),
    }),

    importEcrsWithNotes: build.mutation<void, EcrImportParams>({
      query: (params) => ({
        url: `${ECR_BASE_URL}/excel_import_notes/`,
        params,
      }),
    }),

    ecrTemplate: build.mutation<null, void>({
      query: () => ({
        url: `${ECR_BASE_URL}/export_ecr_template_excel/`,
        method: "GET",
        cache: "no-cache",

        // NOTE: Also using this pattern in files.api.ts
        // may want to consider extracting this pattern
        responseHandler: async (response) => response.blob(),
      }),
      transformResponse: (blob: Blob) => {
        fileDownload(blob, "ecr_comments_template.xlsx");
        return null;
      },
      transformErrorResponse: (e) => {
        console.error(e);
        return { error: "Error Downloading Template" };
      },
    }),
  }),

  overrideExisting: false,
});

export const {
  useImportEcrsMutation,
  useImportEcrsWithNotesMutation,
  useEcrTemplateMutation,
} = ecrExcelApi;
